export default "__VITE_ASSET__C6gx5zVN__"